import { Trash2 } from "react-feather";
import { Link } from "react-router-dom";

const DeleteButton = ({ toggle }) => {
  return (
    <Link
      onClick={(e) => {
        e.preventDefault();
        toggle();
      }}
    >
      <Trash2 color="red" />
    </Link>
  );
};

export default DeleteButton;
